(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name commons.controller:SendSmsCtrl
     *
     * @description
     *
     */
    angular
        .module('messageInbox')
        .controller('ReplyCtrl', ReplyCtrl);

    function ReplyCtrl(MessageService, CommonMasterData, $uibModalInstance, modalParams, MessageInboxService) {
        var vm = this;
        var selectedMessage = modalParams.selectedMessage;
        vm.model = {
    		request : {
    			title : selectedMessage.title,
    			content : selectedMessage.content,
    			messageId : selectedMessage.messageId,
    			version : selectedMessage.version,
    			isReply : selectedMessage.messageId != selectedMessage.parentMessageId
    		},
    		sentBy : selectedMessage.sentBy,
    		maxCharactersInMSG : modalParams.maxCharactersInMSG
        };

        vm.closeMe = function () {
            $uibModalInstance.close();
        };


        vm.onSubmit = function () {
            if(vm.searchAny.$valid){
            	MessageInboxService.replyMessage(vm.model.request,
                    function(data){
                        if(data.success) {
                            $uibModalInstance.close('SUCCESS');
                            MessageService.success('Reply has been sent');
                        }
                    },
                    function(error){
                        MessageService.error(error.msg[0]);
                    }
                );
            }
        };
		
    }
}());
